import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const CONVERSATION_ACTION_TYPES = [
    {
        key: 'assign_agent',
        label: 'Assign to agent',
        inputType: 'search_select',
        attributeI18nKey: 'ASSIGN_AGENT',
    },
    {
        key: 'assign_team',
        label: 'Assign a team',
        inputType: 'search_select',
        attributeI18nKey: 'ASSIGN_TEAM',
    },
    {
        key: 'add_label',
        label: 'Add a label',
        inputType: 'multi_select',
        attributeI18nKey: 'ADD_LABEL',
    },
    {
        key: 'unassign_agent',
        label: 'Unassign agent',
        inputType: null,
        attributeI18nKey: 'UNASSIGN_AGENT',
    },
    {
        key: 'remove_assigned_team',
        label: 'Remove assigned team',
        inputType: null,
        attributeI18nKey: 'REMOVE_ASSIGNED_TEAM',
    },
    {
        key: 'remove_label',
        label: 'Remove label',
        inputType: 'multi_select',
        attributeI18nKey: 'REMOVE_LABEL',
    },
    {
        key: 'send_email_to_team',
        label: 'Send an email to team',
        inputType: 'team_message',
        attributeI18nKey: 'SEND_EMAIL_TO_TEAM',
    },
    {
        key: 'send_email_transcript',
        label: 'Send an email transcript',
        inputType: 'email',
        attributeI18nKey: 'SEND_EMAIL_TRANSCRIPT',
    },
    {
        key: 'mute_conversation',
        label: 'Mute conversation',
        inputType: null,
        attributeI18nKey: 'MUTE_CONVERSATION',
    },
    {
        key: 'snooze_conversation',
        label: 'Snooze conversation',
        inputType: null,
        attributeI18nKey: 'SNOOZE_CONVERSATION',
    },
    {
        key: 'resolve_conversation',
        label: 'Resolve conversation',
        inputType: null,
        attributeI18nKey: 'RESOLVE_CONVERSATION',
    },
    {
        key: 'conversation_opened',
        label: 'Conversation opened',
        inputType: null,
        attributeI18nKey: 'CONVERSATION_OPENED',
    },
    {
        key: 'send_webhook_event',
        label: 'Send Webhook Event',
        inputType: 'url',
        attributeI18nKey: 'SEND_WEBHOOK_EVENT',
    },
    {
        key: 'execute_builder_flow',
        label: 'Execute Builder Flow',
        inputType: 'url',
        attributeI18nKey: 'EXECUTE_BUILDER_FLOW',
    },
    {
        key: 'send_attachment',
        label: 'Send Attachment',
        inputType: 'attachment',
        attributeI18nKey: 'SEND_ATTACHMENT',
    },
    {
        key: 'update_contact_avatar',
        label: 'Update Contact Avatar',
        inputType: 'attachment',
        attributeI18nKey: 'UPDATE_CONTACT_AVATAR',
    },
    {
        key: 'send_message',
        label: 'Send a message',
        inputType: 'textarea',
        attributeI18nKey: 'SEND_MESSAGE',
    },
    {
        key: 'send_private_message',
        label: 'Add internal note',
        inputType: 'textarea',
        attributeI18nKey: 'SEND_PRIVATE_MESSAGE',
    },
    {
        key: 'send_summary_custom_prompt',
        label: 'Generate summary with custom prompt',
        inputType: 'textarea',
        attributeI18nKey: 'SEND_SUMMARY_CUSTOM_PROMPT',
    },
    {
        key: 'change_priority',
        label: 'Change Priority',
        inputType: 'search_select',
        attributeI18nKey: 'CHANGE_PRIORITY',
    },
    {
        key: 'send_whatsapp_message',
        label: 'Send Whatsapp Message',
        inputType: 'send_whatsapp_message',
        attributeI18nKey: 'SEND_WHATSAPP_MESSAGE',
    },
    {
        key: 'send_whatsapp_message_now',
        label: 'Send Template',
        inputType: 'send_whatsapp_message_now',
        attributeI18nKey: 'SEND_WHATSAPP_MESSAGE_NOW',
    },
    {
        key: 'trigger_macro',
        label: 'Trigger a macro',
        inputType: 'search_select',
        attributeI18nKey: 'TRIGGER_MACRO',
    },
    {
        key: 'set_close_reason',
        label: 'Set closing reason',
        inputType: 'search_select',
        attributeI18nKey: 'SET_CLOSE_REASON',
    },
    {
        key: 'prevent_campaign_delivery',
        label: 'Prevent campaign delivery',
        inputType: 'search_select',
        attributeI18nKey: 'PREVENT_CAMPAIGN_DELIVERY',
    },
    {
        key: 'prevent_template_delivery',
        label: 'Prevent template delivery',
        inputType: 'search_select',
        attributeI18nKey: 'PREVENT_TEMPLATE_DELIVERY',
    },
    {
        key: 'prevent_contact_delivery',
        label: 'Prevent contact delivery',
        inputType: 'search_select',
        attributeI18nKey: 'PREVENT_CONTACT_DELIVERY',
    },
    {
        key: 'add_custom_attribute',
        label: 'Add Custom Attribute',
        inputType: 'team_message',
        attributeI18nKey: 'ADD_CUSTOM_ATTRIBUTE',
    },
    {
        key: 'add_contact_custom_attribute',
        label: 'Add Contact Custom Attribute',
        inputType: 'team_message',
        attributeI18nKey: 'ADD_CONTACT_CUSTOM_ATTRIBUTE',
    },
    {
        key: 'send_event_log',
        label: 'Enviar evento de log',
        inputType: 'search_select',
        attributeI18nKey: 'SEND_EVENT_LOG',
    },
    {
        key: 'create_opportunity',
        label: 'Criar oportunidade',
        inputType: 'create_opportunity',
        attributeI18nKey: 'CREATE_OPPORTUNITY',
        featureFlag: FEATURE_FLAGS.OPPORTUNITY_PIPELINES,
    },
];

export const OPPORTUNITY_ACTION_TYPES = [
    {
        key: 'change_opportunity_stage',
        label: 'Alterar etapa da oportunidade',
        inputType: 'search_select',
        attributeI18nKey: 'CHANGE_OPPORTUNITY_STAGE',
    },
    {
        key: 'change_opportunity_owner',
        label: 'Alterar responsável pela oportunidade',
        inputType: 'search_select',
        attributeI18nKey: 'CHANGE_OPPORTUNITY_OWNER',
    },
    {
        key: 'change_opportunity_status',
        label: 'Alterar status da oportunidade',
        inputType: 'search_select',
        attributeI18nKey: 'CHANGE_OPPORTUNITY_STATUS',
    },
    {
        key: 'change_opportunity_value',
        label: 'Alterar valor da oportunidade',
        inputType: 'number',
        attributeI18nKey: 'CHANGE_OPPORTUNITY_VALUE',
    },
    {
        key: 'create_opportunity_note',
        label: 'Criar anotação na oportunidade',
        inputType: 'textarea',
        attributeI18nKey: 'CREATE_OPPORTUNITY_NOTE',
    },
    {
        key: 'change_opportunity_temperature',
        label: 'Alterar temperatura da oportunidade',
        inputType: 'search_select',
        attributeI18nKey: 'CHANGE_OPPORTUNITY_TEMPERATURE',
    },
    {
        key: 'create_opportunity_activity',
        label: 'Criar atividade na oportunidade',
        inputType: 'opportunity_activity',
        attributeI18nKey: 'CREATE_OPPORTUNITY_ACTIVITY',
    },
];

export const AUTOMATION_ACTION_TYPES = [
  ...CONVERSATION_ACTION_TYPES,
  ...OPPORTUNITY_ACTION_TYPES,
];
